/* Shared display helpers and static reference content for the partner
   portal (pricing-tier comparison, status/color lookups, formatting). Live
   account data — sessions, keys, candidate pool, billing — comes from the
   API via services/partnerCalls.js, not from this file. */

export const FX = 1420; // USD -> NGN, display only
export const TEAL = "#2dd4bf";

export function money(usd, currency) {
  if (usd == null) return "Custom";
  if (currency === "NGN") return "₦" + Math.round(usd * FX).toLocaleString();
  return "$" + (Number.isInteger(usd) ? usd.toLocaleString() : usd.toFixed(2));
}

// Which row is "CURRENT" is decided in Billing.jsx by comparing tier.name
// against the real balance/allocation the API returns, not a static flag
// here — that flag used to mark "Growth" as everyone's current plan.
export const TIERS = [
  { name: "One-off pack", commit: "No commitment", per: 1.5 },
  { name: "Starter", commit: "10,000+ / yr", per: 1.1 },
  { name: "Growth", commit: "50,000+ / yr", per: 0.85 },
  { name: "Scale", commit: "150,000+ / yr", per: 0.65 },
  { name: "Enterprise", commit: "500,000+ / yr", per: 0.5 },
];

export const STATUS_CLASS = {
  completed: "pillCompleted",
  in_progress: "pillInProgress",
  pending: "pillPending",
  expired: "pillExpired",
};

export const AV_GRAD = [
  "linear-gradient(135deg,#2dd4bf,#0f766e)",
  "linear-gradient(135deg,#38bdf8,#1d4ed8)",
  "linear-gradient(135deg,#a78bfa,#7c3aed)",
  "linear-gradient(135deg,#fbbf24,#ea580c)",
  "linear-gradient(135deg,#f472b6,#db2777)",
  "linear-gradient(135deg,#34d399,#059669)",
];

export const fitColor = (v) =>
  v >= 85 ? "#22c55e" : v >= 72 ? "#38bdf8" : "#fbbf24";

export const initialsOf = (n) =>
  (n || "")
    .replace(/[^A-Za-z. ]/g, "")
    .split(/[.\s]+/)
    .filter(Boolean)
    .map((x) => x[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export const downloadCsv = (filename, text) => {
  try {
    const blob = new Blob([text], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (_) {}
};

export const copyText = (text) => {
  try {
    navigator.clipboard.writeText(text);
  } catch (_) {}
};
